import { computed, observable, action } from 'mobx';

class State {
  @observable language = 'de'
  @observable title = 'nett-doctor'
  @observable user = null
  @observable disclaimerAccepted = false

  @observable patientInformation = {
    age: null,
    gender: null,
    height: null,
    weight: null,
    inGermanySince: null,
    wayToGermany: null,
    foreName: null,
    lastName: null
  }

  @observable symptoms = {
    pain: false,
    breathingProblems: false,
    problemsOfDigestion: false,
    raisedBodyTemperature: false,
    dizziness: false,
    weaknessOrExhaustion: false,
    rashItchRedness: false,
    paralysisDeafnessPrickle: false,
    sensoryPerception: false,
    gynecologicalIssues: false,
    swelling: false,
    childrensDisease: false
  }

  @observable painDetails = {
    submitted: false,
    since: null,
    when: null,
    trigger: null,
    painDependingOnSituation: null,
    painSituation: null,
    quality: null
  }

  @observable breathingProblemsDetails = {
    submitted: false,
    since: null,
    breathShortage: null,
    stopBreathingAtNight: null,
    problemsSleeping: null,
    onlySleepWhileSitting: null,
    veryLoudSnore: null,
    swollenLegs: null,
    breathShortageWhen: null,
    cough: null,
    coughHow: null,
    coughWhen: null,
    raspy: null,
    tabacco: null,
    breathShortageWhileExercising: null,
    breathShortageWhileNotMoving: null,
    pressureOnRibcage: null,
    pressureOnRibcageWhen: null
  }
  
  @observable problemsOfDigestionDetails = {
    submitted: false,
    since: null,
    feelingSick: null,
    threwUp: null,
    threwUpType: null,
    diarrhea: null,
    diarrheaCount: null,
    diarrheaTexture: null,
    bloodyExcrements: null,
    fever: null,
    costiveness: null,
    costivenessLastDefecation: null,
    costivenessLiquidAmount: null,
    lessAppetite: null,
    normalAppetite: null,
    possibleSpoiledFood: null,
    nearSurroundingSick: null
  }

  @observable raisedBodyTemperatureDetails = {
    submitted: false,
    since: null,
    measured: null,
    measuredValueInDegrees: null,
    growingPain: null,
    cough: null,
    coughWithoutBloodyAdditives: null,
    throatHurts: null,
    cold: null,
    earsHurt: null,
    nearSurroundingSick: null,
    painUrinating: null,
    rash: null,
    stomachAche: null
  }

  @observable dizzinessDetails = {
    submitted: false,
    since: null,
    when: null,
    sickOrThrewUp: null,
    hearingWorse: null,
    earSounds: null,
    earSoundsOn: null,
    threwUp: null,
    lostConciousness: null,
    lostConciousnessCount: null,
    lostConciousnessHeartRacing: null,
    lostConciousnessEarSounds: null,
    lostConciousnessHotCold: null
  }

  @observable weaknessOrExhaustionDetails = {
    submitted: false,
    tumorOrCancer: null,
    weightLoss: null,
    sweatAtNight: null,
    heavySweatAtNight: null,
    bloodyStool: null,
    bloodyCough: null,
    heartDisease: null
  }

  @observable rashItchRednessDetails = {
    submitted: false,
    type: null,
    location: [],
    since: null,
    behavior: null,
    skinMoistens: null,
    skinScalesOff: null,
    skinUlcerate: null,
    skinIsSwollen: null,
    contactWithSkinDiseasePeople: null,
    contactWithToxicMaterial: null,
    stungByInsect: null,
    injury: null,
    injuryLocation: [],
    allergic: null,
    diagnosedSkinDisease: null,
    diagnosedSkinDiseaseInFamily: null
  }

  @observable paralysisDeafnessPrickleDetails = {
    submitted: false,
    injuryOrAccident: null,
    knownBackProblems: null,
    slippedOrHerniatedDisc: null,
    neuralDisease: null,
    multipleSclerosis: null,
    tumorAffectingNervousSystem: null,
    alreadySufferedStroke: null,
    numbness: null,
    paralysis: null,
    prickle: null,
    lossOfPower: null,
  }

  @observable sensoryPerceptionDetails = {
    submitted: false,
    lossOfTastePerception: null,
    auditivePerceptionGotWorse: null,
    sightDisorder: null,
    senseOfSmellGotWorse: null
  }

      @observable numbnessDetails = {
        location: [],
        differentPerceptionInBodyHalfs: null,
        since: null,
        how: null
      }

      @observable paralysisDetails = {
        location: [],
        limitedToOneBodyHalf: null,
        since: null,
        how: null,
        feelingDizzy: null
      }

      @observable prickleDetails = {
        location: [],
        limitedToOneBodyHalf: null,
        since: null,
        how: null,
        quality: null
      }

      @observable lossOfPowerDetails = {
        location: [],
        limitedToOneBodyHalf: null,
        since: null,
        how: null
      }

      @observable lossOfTastePerceptionDetails = {
        since: null,
        how: null,
        cannotTasteAnything: null,
        noDifferenceBetweenHotAndCold: null,
        cannotTasteFlavor: null
      }

      @observable auditivePerceptionGotWorseDetails = {
        affectedEars: null,
        cannotHearAnything: null,
        cannotHearAnythingOnEars: null,
        feelingDizzy: null,
        painInEars: null,
        since: null,
        how: null
      }

      @observable sightDisorderDetails = {
        affectedEyes: null,
        seeingFuzzy: null,
        troubleSeeingNear: null,
        troubleSeeingFar: null,
        seeingDouble: null,
        sightLimitedToSides: null,
        cannotDifferenciateColors: null,
        feelingDizzy: null,
        since: null,
        how: null
      }

      @observable senseOfSmellGotWorseDetails = {
        lostSenseOfSmell: null,
        onlySpicyAndUnpleasentSmells: null,
        since: null,
        how: null
      }

  @observable gynecologicalIssuesDetails = {
    submitted: false,
    since: null,
    difficultiesDefecating: null,
    difficultiesUrinating: null,
    difficultiesUrinatingBurningPerception: null,
    difficultiesUrinatingNotPossible: null,
    difficultiesUrinatingBloodyUrine: null,
    generalMenstruationDisorder: null,
    menstruationWithPain: null,
    problemsBreastFeeding: null,
    painDuringCoitus: null,
    breastPain: null,
    breastNodes: null,
    nippleEfflux: null,
    vaginalEfflux: null,
    vaginalEffluxType: null,
    firstDayOfMonthlyMenstruation: null,
    vaginalItchiness: null,
    menopause: null,
    passedMenopause: null,
    possiblePregnancy: null,
    sexFrequently: null,
    neverHadSex: null,
    protection: null,
    protectionType: null,
    frequentMenstruationCycle: null,
    pregnantBefore: null,
    hasChildren: null,
    childrenCount: null,
    birthComplications: null,
    abortion: null,
    lostChildToComplications: null,
    birthType: null,
    childrenAges: null,
    surgeryOn: null,
    familyDiseases: null,
    malignantDiseaseOnOrgans: null,
    lastGynecologicalVisit: null
  }

  @observable swellingDetails = {
    submitted: false,
    location: [],
    coldPastWeeks: null,
    teethHurt: null,
    developedSlowly: null,
    developedSuddenly: null,
    hurts: null,
    hurtIsGetting: null,
    redness: null,
    rednessGetting: null,
    strongestSwellingTime: null,
    incidentShortlyBeforeSwelling: null,
    otherDiseases: null
  }

  @observable childrensDiseaseDetails = {
    todo: null
  }
  
  @observable additionalConditions = {
    sadness: null,
    panicAttacks: null,
    pregnancy: null,
    takingMedicine: null
  }

  @observable pregnancyDetails = {
    submitted: false,
    reportAvailable: null,
    pregnancyInWeeks: null,
    bloodGroupAbZ: null,
    bloodGroupRhesusFactor: null,
    lastGynecologicalVisit: null
  }

  @observable medicalHistory = {
    autoimmuneDisease: null,
    hadSurgeryBefore: null,
    hadSurgeryBeforeLocation: [],

    cardiovascularDisease: {
        heartRythmDisorder: null,
        tachcardia: null,
        tachcardiaSince: null,
        extrasystole: null,
        heartPaceMaker: null,
        takingMedicine: null,
        highBloodPressure: null,
        cardiovascularObliteration: null,
        hadSurgery: null
    },

    metabolismDisorder: {
        diabetes: null,
        pills: null,
        insulinInjections: null,
        thyroidGlandDisorder: null,
        bloodCoagulationDisfunction: null,
        allergicReactionToMedicaments: null,
        otherAllergies: null,
        hasTumorOrCancer: null,
        chemotherapy: null,
        radiationTherapy: null,
        arthrosis: null,
        rheumatism: null,
        chronicalInflammatoryIntestine: null,
        colitis: null,
        morbusCrohn: null,
        pulmonaryDisease: null,
        chronicalPulmonaryDisease: null,
        asthma: null,
    },

    infectiousDisease: {
        hiv: null,
        viralHepatitis: null,
        syphilis: null,
        tuberculosis: null,
        cholera: null,
        varicella: null,
        measles: null,
        rubella: null,
        diphteria: null,
        typhus: null
    },

    substanceConsume: null
  }

/**
 * VALIDATE INFORMATION
 */

  _validateInformation(type, exceptions) {
    let notRequired = exceptions || []
    let check = true
    for ( const detail in this[type]) {
      if (!notRequired.includes(detail)) {
        const value = this[type][detail]
        if (value === null || value === '' || value.length <= 0) {
          check = false
        }
      }
    }
    return check
  }

  @computed get patientInformationComplete() {
    const exceptions = [
      'foreName', 'lastName'
    ]
    return this._validateInformation('patientInformation', exceptions)
  }

  @computed get pregnancyDetailsComplete() {
    const exceptions = [
      'pregnancyInWeeks',
      'bloodGroupAbZ',
      'bloodGroupRhesusFactor',
      'lastGynecologicalVisit'
    ]
    return this._validateInformation('pregnancyDetails', exceptions)
  }

  @computed get painDetailsComplete() {
    const exceptions = [
      'painDependingOnSituation',
      'painSituation'
    ]
    return this._validateInformation('painDetails', exceptions)
  }

  @computed get breathingProblemsDetailsComplete() {
    const exceptions = [
      'breathShortageWhen',
      'coughHow',
      'coughWhen',
      'raspy',
      'breathShortageWhileExercising',
      'breathShortageWhileNotMoving',
      'pressureOnRibcageWhen'
    ]
    return this._validateInformation('breathingProblemsDetails', exceptions)
  }

  @computed get problemsOfDigestionDetailsComplete() {
    const exceptions = [
      'threwUpType',
      'diarrheaCount',
      'diarrheaTexture',
      'bloodyExcrements',
      'fever',
      'costiveness',
      'costivenessLastDefecation',
      'costivenessLiquidAmount',
      'lessAppetite',
      'normalAppetite',
      'possibleSpoiledFood',
      'nearSurroundingSick'
    ]
    return this._validateInformation('problemsOfDigestionDetails', exceptions)
  }

  @computed get raisedBodyTemperatureDetailsComplete() {
    const exceptions = [
      'measured',
      'measuredValueInDegrees',
      'growingPain',
      'coughWithoutBloodyAdditives',
      'throatHurts',
      'cold',
      'earsHurt',
      'rash',
      'stomachAche'
    ]
    return this._validateInformation('raisedBodyTemperatureDetails', exceptions)
  }

  @computed get dizzinessDetailsComplete() {
    const exceptions = [
      'when',
      'sickOrThrewUp',
      'hearingWorse',
      'earSounds',
      'earSoundsOn',
      'lostConciousnessCount',
      'lostConciousnessHeartRacing',
      'lostConciousnessEarSounds',
      'lostConciousnessHotCold'
    ]
    return this._validateInformation('dizzinessDetails', exceptions)
  }

  @computed get weaknessOrExhaustionDetailsComplete() {
    const exceptions = [
      'tumorOrCancer',
      'weightLoss',
      'sweatAtNight',
      'heavySweatAtNight',
      'bloodyStool',
      'bloodyCough',
      'heartDisease'
    ]
    return this._validateInformation('weaknessOrExhaustionDetails', exceptions)
  }

  @computed get rashItchRednessDetailsComplete() {
    const exceptions = [
      'location',
      'behavior',
      'skinMoistens',
      'skinScalesOff',
      'skinUlcerate',
      'skinIsSwollen',
      'injury',
      'injuryLocation',
      'allergic',
      'diagnosedSkinDisease',
      'diagnosedSkinDiseaseInFamily'
    ]
    return this._validateInformation('rashItchRednessDetails', exceptions)
  }

  @computed get paralysisDeafnessPrickleDetailsComplete() {
    const exceptions = [
      'injuryOrAccident',
      'knownBackProblems',
      'slippedOrHerniatedDisc',
      'neuralDisease',
      'multipleSclerosis',
      'tumorAffectingNervousSystem',
      'alreadySufferedStroke',
    ]
    return this._validateInformation('paralysisDeafnessPrickleDetails', exceptions)
  }

  @computed get sensoryPerceptionDetailsComplete() {
    const exceptions = [
      'sightDisorder',
      'senseOfSmellGotWorse'
    ]
    return this._validateInformation('sensoryPerceptionDetails', exceptions)
  }

  @computed get gynecologicalIssuesDetailsComplete() {
    const exceptions = [
      'difficultiesUrinatingBurningPerception',
      'difficultiesUrinatingNotPossible',
      'difficultiesUrinatingBloodyUrine',
      'generalMenstruationDisorder',
      'menstruationWithPain',
      'problemsBreastFeeding',
      'painDuringCoitus',
      'breastPain',
      'breastNodes',
      'nippleEfflux',
      'vaginalEfflux',
      'vaginalEffluxType',
      'firstDayOfMonthlyMenstruation',
      'vaginalItchiness',
      'menopause',
      'passedMenopause',
      'possiblePregnancy',
      'sexFrequently',
      'neverHadSex',
      'protection',
      'protectionType',
      'frequentMenstruationCycle',
      'pregnantBefore',
      'hasChildren',
      'childrenCount',
      'birthComplications',
      'abortion',
      'lostChildToComplications',
      'birthType',
      'childrenAges',
      'surgeryOn',
      'familyDiseases',
      'malignantDiseaseOnOrgans',
      'lastGynecologicalVisit'
    ]
    return this._validateInformation('gynecologicalIssuesDetails', exceptions)
  }

  @computed get swellingDetailsComplete() {
    const exceptions = [
      'coldPastWeeks',
      'teethHurt',
      'developedSlowly',
      'developedSuddenly',
      'hurts',
      'hurtIsGetting',
      'redness',
      'rednessGetting',
      'strongestSwellingTime',
      'incidentShortlyBeforeSwelling',
      'otherDiseases'
    ]
    return this._validateInformation('swellingDetails', exceptions)
  }

  @computed get childrensDiseaseDetailsComplete() {
    const exceptions = []
    return this._validateInformation('childrensDiseaseDetails', exceptions)
  }

  @computed get medicalHistoryComplete() {
    const exceptions = [
      'hadSurgeryBeforeLocation',
      'cardiovascularDisease',
      'metabolismDisorder',
      'infectiousDisease' 
    ]
    return this._validateInformation('medicalHistory', exceptions)
  }

  @computed get symptomDetailsComplete() {
    let check = true
    let detailCounter = 0
    for ( const symptom in this.symptoms ) {
      const value = this.symptoms[symptom]
      if (value) {
        detailCounter++
        if (symptom !== 'childrensDisease' && (!this[symptom+'DetailsComplete'] || !this[symptom+'Details'].submitted)) {
          check = false
        }
      }
    }
    if (detailCounter === 0) check = false
    return check
  }

  @computed get symptomsComplete() {
    return (
      this.additionalConditions.sadness !== null &&
      this.additionalConditions.panicAttacks !== null &&
      this.additionalConditions.pregnancy !== null &&
      ( this.additionalConditions.takingMedicine === 'yes' ||
        this.additionalConditions.takingMedicine === 'no'
      ) &&
      ( this.symptoms.pain || 
        this.symptoms.breathingProblems ||
        this.symptoms.problemsOfDigestion ||
        this.symptoms.raisedBodyTemperature ||
        this.symptoms.dizziness ||
        this.symptoms.weaknessOrExhaustion ||
        this.symptoms.rashItchRedness ||
        this.symptoms.paralysisDeafnessPrickle ||
        this.symptoms.sensoryPerception ||
        this.symptoms.gynecologicalIssues ||
        this.symptoms.swelling ||
        this.symptoms.childrensDisease
      )
    )
  }

  /**
   * PERSIST INFORMATION
   */

  _persistInformation(type) {
    const typeData = JSON.parse(localStorage.getItem(type))
    if (typeData) {
      for (const prop in typeData) {
        this[type][prop] = typeData[prop]
      }
    }
  }

  @action.bound persistDisclaimer() {
    const disclaimerInfo = JSON.parse(localStorage.getItem('disclaimerAccepted'))
    this.disclaimerAccepted = disclaimerInfo
  }

  @action.bound persistPatientInformation() {
    this._persistInformation('patientInformation')
  }

  @action.bound persistBasicInformation() {
    this._persistInformation('patientInformation')
    const user = localStorage.getItem('user')
    if (user) {
      this.user = user
    }
  }

  @action.bound persistSymptoms() {
    this._persistInformation('symptoms')
  }

  @action.bound persistAdditionalConditions() {
    this._persistInformation('additionalConditions')
  }

  @action.bound persistSymptomDetails() {
    const symptomDetailsToPersist = []
    for ( const symptom in this.symptoms ) {
      if( this.symptoms[symptom] ) {
        symptomDetailsToPersist.push(symptom+'Details')
      }
    }
    symptomDetailsToPersist.forEach( symptomDetail => {
      this._persistInformation(symptomDetail)
    })
  }

  @action.bound persistAdditionalConditionDetails() {
    const additionalConditionsToPersist = []
    for ( const condition in this.additionalConditions ) {
      if( this.additionalConditions[condition] ) {
        additionalConditionsToPersist.push(condition+'Details')
      }
    }
    additionalConditionsToPersist.forEach( conditionDetail => {
      this._persistInformation(conditionDetail)
    })
  }

  @action.bound persistMedicalHistory() {
    const data = JSON.parse(localStorage.getItem('medicalHistory'))
    if (data) {
      for ( const prop in data ) {
        if (typeof data[prop] === 'object' && prop !== 'substanceConsume') {
          for ( const entry in data[prop] ) {
            this.medicalHistory[prop][entry] = data[prop][entry]
          }
        } else {
          this.medicalHistory[prop] = data[prop]
        }
      }
    }
  }

  @action.bound persistParalysisDeafnessPrickleDetails() {
    for (const perception in this.paralysisDeafnessPrickleDetails) {
      const value = this.paralysisDeafnessPrickleDetails[perception]
      if (value === 'yes' && typeof this[perception+'Details'] === 'object') {
        this._persistInformation(perception+'Details')
      }
    }
  }

  @action.bound persistSensoryPerceptionDetails() {
    for (const perception in this.sensoryPerceptionDetails) {
      const value = this.sensoryPerceptionDetails[perception]
      if (value === 'yes' && typeof this[perception+'Details'] === 'object') {
        this._persistInformation(perception+'Details')
      }
    }
  }

/**
 * ADD INFORMATION
 */

  @action.bound addPatientInformation(type, value) {
    if ([type] in this.patientInformation) {
      this.patientInformation[type] = value
    }
  }

  @action.bound addSymptom(type, value) {
    if ([type] in this.symptoms) {
      this.symptoms[type] = value
    }
  }

  @action.bound addAdditionalConditions(type, value) {
    if ([type] in this.additionalConditions) {
      this.additionalConditions[type] = value
    }
  }

  @action.bound addPregnancyDetails(type, value) {
    if ([type] in this.pregnancyDetails) {
      this.pregnancyDetails[type] = value
      this.pregnancyDetails.submitted = false
    }
  }

  @action.bound addPainDetails(type, value) {
    if ([type] in this.painDetails) {
      this.painDetails[type] = value
      this.painDetails.submitted = false
    }
  }

  @action.bound addBreathingProblemsDetails(type, value) {
    if ([type] in this.breathingProblemsDetails) {
      this.breathingProblemsDetails[type] = value
      this.breathingProblemsDetails.submitted = false
    }
  }

  @action.bound addProblemsOfDigestionDetails(type, value) {
    if ([type] in this.problemsOfDigestionDetails) {
      this.problemsOfDigestionDetails[type] = value
      this.problemsOfDigestionDetails.submitted = false
    }
  }

  @action.bound addRaisedBodyTemperatureDetails(type, value) {
    if ([type] in this.raisedBodyTemperatureDetails) {
      this.raisedBodyTemperatureDetails[type] = value
      this.raisedBodyTemperatureDetails.submitted = false
    }
  }

  @action.bound addDizzinessDetails(type, value) {
    if ([type] in this.dizzinessDetails) {
      this.dizzinessDetails[type] = value
      this.dizzinessDetails.submitted = false
    }
  }

  @action.bound addRashItchRednessDetails(type, value) {
    if ([type] in this.rashItchRednessDetails) {
      this.rashItchRednessDetails[type] = value
      this.rashItchRednessDetails.submitted = false
    }
  }

  @action.bound addWeaknessOrExhaustionDetails(type, value) {
    if ([type] in this.weaknessOrExhaustionDetails) {
      this.weaknessOrExhaustionDetails[type] = value
      this.weaknessOrExhaustionDetails.submitted = false
    }
  }

  @action.bound addParalysisDeafnessPrickleDetails(type, value) {
    if ([type] in this.paralysisDeafnessPrickleDetails) {
      this.paralysisDeafnessPrickleDetails[type] = value
      this.paralysisDeafnessPrickleDetails.submitted = false
    }
  }

  @action.bound addSensoryPerceptionDetails(type, value) {
    if ([type] in this.sensoryPerceptionDetails) {
      this.sensoryPerceptionDetails[type] = value
      this.sensoryPerceptionDetails.submitted = false
    }
  }

  @action.bound addNumbnessDetails(type, value) {
    if ([type] in this.numbnessDetails) {
      this.numbnessDetails[type] = value
      this.paralysisDeafnessPrickleDetails.submitted = false
    }
  }

  @action.bound addParalysisDetails(type, value) {
    if ([type] in this.paralysisDetails) {
      this.paralysisDetails[type] = value
      this.paralysisDeafnessPrickleDetails.submitted = false
    }
  }

  @action.bound addPrickleDetails(type, value) {
    if ([type] in this.prickleDetails) {
      this.prickleDetails[type] = value
      this.paralysisDeafnessPrickleDetails.submitted = false
    }
  }

  @action.bound addLossOfPowerDetails(type, value) {
    if ([type] in this.lossOfPowerDetails) {
      this.lossOfPowerDetails[type] = value
      this.paralysisDeafnessPrickleDetails.submitted = false
    }
  }

  @action.bound addLossOfTastePerceptionDetails(type, value) {
    if ([type] in this.lossOfTastePerceptionDetails) {
      this.lossOfTastePerceptionDetails[type] = value
      this.sensoryPerceptionDetails.submitted = false
    }
  }

  @action.bound addSwellingDetails(type, value) {
    if ([type] in this.swellingDetails) {
      this.swellingDetails[type] = value
      this.swellingDetails.submitted = false
    }
  }

  @action.bound addGynecologicalIssuesDetails(type, value) {
    if ([type] in this.gynecologicalIssuesDetails) {
      this.gynecologicalIssuesDetails[type] = value
      this.gynecologicalIssuesDetails.submitted = false
    }
  }

  @action.bound addAuditivePerceptionGotWorseDetails(type, value) {
    if ([type] in this.auditivePerceptionGotWorseDetails) {
      this.auditivePerceptionGotWorseDetails[type] = value
      this.sensoryPerceptionDetails.submitted = false
    }
  }
  
  @action.bound addSightDisorderDetails(type, value) {
    if ([type] in this.sightDisorderDetails) {
      this.sightDisorderDetails[type] = value
      this.sensoryPerceptionDetails.submitted = false
    }
  }
  
  @action.bound addSenseOfSmellGotWorseDetails(type, value) {
    if ([type] in this.senseOfSmellGotWorseDetails) {
      this.senseOfSmellGotWorseDetails[type] = value
      this.sensoryPerceptionDetails.submitted = false
    }
  }

  @action.bound addMedicalHistory(type, value) {
    if ([type] in this.medicalHistory) {
      this.medicalHistory[type] = value
    }
  }

  @action.bound addCardiovascularDiseaseHistory(type, value) {
    if ([type] in this.medicalHistory.cardiovascularDisease) {
      this.medicalHistory.cardiovascularDisease[type] = value
    }
  }

  @action.bound addMetabolismDisorderHistory(type, value) {
    if ([type] in this.medicalHistory.metabolismDisorder) {
      this.medicalHistory.metabolismDisorder[type] = value
    }
  }
  
  @action.bound addInfectiousDiseaseHistory(type, value) {
    if ([type] in this.medicalHistory.infectiousDisease) {
      this.medicalHistory.infectiousDisease[type] = value
    }
  }

  @action.bound addSubstanceConsume(value) {
    this.medicalHistory.substanceConsume = value
  }


  /**
   * RESET STORE
   */
  @action.bound reset() {
    this.language = 'de'
    this.title = 'nett-doctor'
    this.user = null,
    this.disclaimerAccepted = false

    this.patientInformation = {
      age: null,
      gender: null,
      height: null,
      weight: null,
      inGermanySince: null,
      wayToGermany: null,
      foreName: null,
      lastName: null
    }
    this.symptoms = {
      pain: false,
      breathingProblems: false,
      problemsOfDigestion: false,
      raisedBodyTemperature: false,
      dizziness: false,
      weaknessOrExhaustion: false,
      rashItchRedness: false,
      paralysisDeafnessPrickle: false,
      sensoryPerception: false,
      gynecologicalIssues: false,
      swelling: false,
      childrensDisease: false
    }
    this.painDetails = {
      submitted: false,
      since: null,
      when: null,
      trigger: null,
      painDependingOnSituation: null,
      painSituation: null,
      quality: null
    }
    this.breathingProblemsDetails = {
      submitted: false,
      since: null,
      breathShortage: null,
      stopBreathingAtNight: null,
      problemsSleeping: null,
      onlySleepWhileSitting: null,
      veryLoudSnore: null,
      swollenLegs: null,
      breathShortageWhen: null,
      cough: null,
      coughHow: null,
      coughWhen: null,
      raspy: null,
      tabacco: null,
      breathShortageWhileExercising: null,
      breathShortageWhileNotMoving: null,
      pressureOnRibcage: null,
      pressureOnRibcageWhen: null
    }
    this.problemsOfDigestionDetails = {
      submitted: false,
      since: null,
      feelingSick: null,
      threwUp: null,
      threwUpType: null,
      diarrhea: null,
      diarrheaCount: null,
      diarrheaTexture: null,
      bloodyExcrements: null,
      fever: null,
      costiveness: null,
      costivenessLastDefecation: null,
      costivenessLiquidAmount: null,
      lessAppetite: null,
      normalAppetite: null,
      possibleSpoiledFood: null,
      nearSurroundingSick: null
    }
    this.raisedBodyTemperatureDetails = {
      submitted: false,
      since: null,
      measured: null,
      measuredValueInDegrees: null,
      growingPain: null,
      cough: null,
      coughWithoutBloodyAdditives: null,
      throatHurts: null,
      cold: null,
      earsHurt: null,
      nearSurroundingSick: null,
      painUrinating: null,
      rash: null,
      stomachAche: null
    }
    this.dizzinessDetails = {
      submitted: false,
      since: null,
      when: null,
      sickOrThrewUp: null,
      hearingWorse: null,
      earSounds: null,
      earSoundsOn: null,
      threwUp: null,
      lostConciousness: null,
      lostConciousnessCount: null,
      lostConciousnessHeartRacing: null,
      lostConciousnessEarSounds: null,
      lostConciousnessHotCold: null
    }
    this.weaknessOrExhaustionDetails = {
      submitted: false,
      tumorOrCancer: null,
      weightLoss: null,
      sweatAtNight: null,
      heavySweatAtNight: null,
      bloodyStool: null,
      bloodyCough: null,
      heartDisease: null
    }
    this.rashItchRednessDetails = {
      submitted: false,
      type: null,
      location: [],
      since: null,
      behavior: null,
      skinMoistens: null,
      skinScalesOff: null,
      skinUlcerate: null,
      skinIsSwollen: null,
      contactWithSkinDiseasePeople: null,
      contactWithToxicMaterial: null,
      stungByInsect: null,
      injury: null,
      injuryLocation: [],
      allergic: null,
      diagnosedSkinDisease: null,
      diagnosedSkinDiseaseInFamily: null
    }
    this.paralysisDeafnessPrickleDetails = {
      submitted: false,
      injuryOrAccident: null,
      knownBackProblems: null,
      slippedOrHerniatedDisc: null,
      neuralDisease: null,
      multipleSclerosis: null,
      tumorAffectingNervousSystem: null,
      alreadySufferedStroke: null,
      numbness: null,
      paralysis: null,
      prickle: null,
      lossOfPower: null,
    }
    this.sensoryPerceptionDetails = {
      submitted: false,
      lossOfTastePerception: null,
      auditivePerceptionGotWorse: null,
      sightDisorder: null,
      senseOfSmellGotWorse: null
      }
        this.numbnessDetails = {
          location: [],
          differentPerceptionInBodyHalfs: null,
          since: null,
          how: null
        }
        this.paralysisDetails = {
          location: [],
          limitedToOneBodyHalf: null,
          since: null,
          how: null,
          feelingDizzy: null
        }
        this.prickleDetails = {
          location: [],
          limitedToOneBodyHalf: null,
          since: null,
          how: null,
          quality: null
        }
        this.lossOfPowerDetails = {
          location: [],
          limitedToOneBodyHalf: null,
          since: null,
          how: null
        }
        this.lossOfTastePerceptionDetails = {
          since: null,
          how: null,
          cannotTasteAnything: null,
          noDifferenceBetweenHotAndCold: null,
          cannotTasteFlavor: null
        }
        this.auditivePerceptionGotWorseDetails = {
          affectedEars: null,
          cannotHearAnything: null,
          cannotHearAnythingOnEars: null,
          feelingDizzy: null,
          painInEars: null,
          since: null,
          how: null
        }
        this.sightDisorderDetails = {
          affectedEyes: null,
          seeingFuzzy: null,
          troubleSeeingNear: null,
          troubleSeeingFar: null,
          seeingDouble: null,
          sightLimitedToSides: null,
          cannotDifferenciateColors: null,
          feelingDizzy: null,
          since: null,
          how: null
        }
        this.senseOfSmellGotWorseDetails = {
          lostSenseOfSmell: null,
          onlySpicyAndUnpleasentSmells: null,
          since: null,
          how: null
        }
    this.gynecologicalIssuesDetails = {
      submitted: false,
      since: null,
      difficultiesDefecating: null,
      difficultiesUrinating: null,
      difficultiesUrinatingBurningPerception: null,
      difficultiesUrinatingNotPossible: null,
      difficultiesUrinatingBloodyUrine: null,
      generalMenstruationDisorder: null,
      menstruationWithPain: null,
      problemsBreastFeeding: null,
      painDuringCoitus: null,
      breastPain: null,
      breastNodes: null,
      nippleEfflux: null,
      vaginalEfflux: null,
      vaginalEffluxType: null,
      firstDayOfMonthlyMenstruation: null,
      vaginalItchiness: null,
      menopause: null,
      passedMenopause: null,
      possiblePregnancy: null,
      sexFrequently: null,
      neverHadSex: null,
      protection: null,
      protectionType: null,
      frequentMenstruationCycle: null,
      pregnantBefore: null,
      hasChildren: null,
      childrenCount: null,
      birthComplications: null,
      abortion: null,
      lostChildToComplications: null,
      birthType: null,
      childrenAges: null,
      surgeryOn: null,
      familyDiseases: null,
      malignantDiseaseOnOrgans: null,
      lastGynecologicalVisit: null
    }
    this.swellingDetails = {
      submitted: false,
      location: [],
      coldPastWeeks: null,
      teethHurt: null,
      developedSlowly: null,
      developedSuddenly: null,
      hurts: null,
      hurtIsGetting: null,
      redness: null,
      rednessGetting: null,
      strongestSwellingTime: null,
      incidentShortlyBeforeSwelling: null,
      otherDiseases: null
    }
    this.childrensDiseaseDetails = {
      todo: null
    }
    this.additionalConditions = {
      sadness: null,
      panicAttacks: null,
      pregnancy: null,
      takingMedicine: null
    }
    this.pregnancyDetails = {
      submitted: false,
      reportAvailable: null,
      pregnancyInWeeks: null,
      bloodGroupAbZ: null,
      bloodGroupRhesusFactor: null,
      lastGynecologicalVisit: null
    }
    this.medicalHistory = {
      autoimmuneDisease: null,
      hadSurgeryBefore: null,
      hadSurgeryBeforeLocation: [],
  
      cardiovascularDisease: {
          heartRythmDisorder: null,
          tachcardia: null,
          tachcardiaSince: null,
          extrasystole: null,
          heartPaceMaker: null,
          takingMedicine: null,
          highBloodPressure: null,
          cardiovascularObliteration: null,
          hadSurgery: null
      },
  
      metabolismDisorder: {
          diabetes: null,
          pills: null,
          insulinInjections: null,
          thyroidGlandDisorder: null,
          bloodCoagulationDisfunction: null,
          allergicReactionToMedicaments: null,
          otherAllergies: null,
          hasTumorOrCancer: null,
          chemotherapy: null,
          radiationTherapy: null,
          arthrosis: null,
          rheumatism: null,
          chronicalInflammatoryIntestine: null,
          colitis: null,
          morbusCrohn: null,
          pulmonaryDisease: null,
          chronicalPulmonaryDisease: null,
          asthma: null,
      },
  
      infectiousDisease: {
          hiv: null,
          viralHepatitis: null,
          syphilis: null,
          tuberculosis: null,
          cholera: null,
          varicella: null,
          measles: null,
          rubella: null,
          diphteria: null,
          typhus: null
      },
  
      substanceConsume: null
    }
  }
}

const state = new State()
export default state